export default "__VITE_ASSET__DsYqx0dw__"